import jobs from "./reducer";

export default jobs;
